export default __webpack_public_path__ + "static/media/reload.f840fcea.svg";